var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vbg-ff-root-container"},[(this.whichRealm)?_c('Header'):_vm._e(),_c('div',{staticClass:"vbg-ff-content-container"},[_c('router-view')],1),(this.whichRealm)?_c('Footer',{staticClass:"footer-margin-top"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }